export default "偽 僞|啟 啓|吃 喫|嫻 嫺|媯 嬀|峰 峯|么 幺|稜 棱|梁 樑|簷 檐|汙 污|洩 泄|溈 潙|潀 潨|為 爲|床 牀|痺 痹|痴 癡|皂 皁|著 着|睪 睾|秘 祕|灶 竈|粽 糉|韁 繮|才 纔|群 羣|唇 脣|參 蔘|蒍 蔿|眾 衆|裡 裏|核 覈|踴 踊|缽 鉢|針 鍼|鯰 鮎|麵 麪|顎 齶";
//# sourceMappingURL=TWVariantsRev.js.map